import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@nucleus-commerce/ui/components/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@nucleus-commerce/ui/components/select';

import type { Store } from '@/shared/store/store-context';

/** The store whose key the playground sends; the docs live outside `/s/$storeId`. */
export function StorePicker({
  stores,
  storeId,
  onChange,
}: {
  stores: readonly Store[];
  storeId: string;
  onChange: (storeId: string) => void;
}) {
  const { t } = useTranslation('docs');
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{t('keys.store')}</Label>
      <Select value={storeId} onValueChange={onChange}>
        <SelectTrigger id={id} className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {stores.map((store) => (
            <SelectItem key={store.id} value={store.id}>
              {store.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
